import notificationWithIcon from 'components/Notification/notificationWithIcon';
import settings from 'constants/settings';
import { put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/types';
import { hanhtrangsoLogin, sachsoLogin, sachsoRegister } from '../services';

const alert = () => {
  notificationWithIcon('warning', 'Thông báo', 'Tài khoản không tồn tại hoặc sai mật khẩu!');
};

// SSO
function* AUTH_LOGIN(action) {
  try {
    const { email, password } = action.payload;
    try {
      // Call api of HANHTRANGSO
      if (!settings.IS_SACHSO) {
        const loggedInUser = yield sachsoLogin(email, password);
        // console.log('🚀 ~ sachsoUser - loggedInUser', loggedInUser);
        if (loggedInUser) {
          yield put({
            type: actionTypes.AUTH_LOGIN_SUCCESS,
            payload: loggedInUser,
          });
        } else {
          alert();
          yield put({ type: actionTypes.AUTH_LOGIN_FAILURE, payload: null });
        }
      } else {
        const hanhtrangsoUser = yield hanhtrangsoLogin(email, password);
        // console.log('🚀 ~ hanhtrangsoUser', hanhtrangsoUser);
        if (hanhtrangsoUser) {
          const sachsoUser = yield sachsoRegister(hanhtrangsoUser);
          const finalUser = {
            ...sachsoUser,
            ...hanhtrangsoUser,
          };
          // console.log('🚀', finalUser);
          yield put({
            type: actionTypes.AUTH_LOGIN_SUCCESS,
            payload: finalUser,
          });
        } else {
          alert();
          yield put({ type: actionTypes.AUTH_LOGIN_FAILURE, payload: null });
        }
      }
    } catch (err) {
      // if HANTRANGSO ERROR => Call api of AMES247
      // console.log('🚀 ~ sachsoUser', err);
      const loggedInUser = yield sachsoLogin(email, password);
      // console.log('🚀 ~ sachsoUser - loggedInUser', loggedInUser);
      if (loggedInUser) {
        yield put({
          type: actionTypes.AUTH_LOGIN_SUCCESS,
          payload: loggedInUser,
        });
      } else {
        alert();
        yield put({ type: actionTypes.AUTH_LOGIN_FAILURE, payload: null });
      }
    }
  } catch (error) {
    alert();
    yield put({ type: actionTypes.AUTH_LOGIN_FAILURE, payload: error });
  }
}

export default function* sagasLogin() {
  yield takeLatest(actionTypes.AUTH_LOGIN, AUTH_LOGIN);
}
